<div AddsRtl class="grid-wrapper w-100 new-grid">
  <div class="w-100 fixed-height-table">
  
    <group-by-menu id="GroupingMenu" [ngClass]="{ active: showGroupMenu }" [columns]="groupColumnsOptions"
      [selectedCol]="selectedGroupByCol" (changed)="onGroupByChanged($event)" ></group-by-menu>
    <ng-container *ngIf="dataList && !isLoading">
      <p-table #ADVGrid [value]="dataList" [paginator]="paginator" [rows]="pageSize"
       [resizableColumns]="false"      [reorderableColumns]="true"
       [columns]="columns"
        [rowsPerPageOptions]="rowsPerPageOptions" [responsive]="responsive" [totalRecords]="totalRecordsLength"
        [styleClass]="styleClass" [lazy]="lazy" [(first)]="firstIndex"
        [currentPageReportTemplate]="currentPageReportTemplate" [showCurrentPageReport]="true"
        [selectionPageOnly]="true" [scrollable]="true" [dataKey]="recordKey" [(selection)]="selectedRecords"
        [exportHeader]="'customExportHeader'"
        (onFilter)="onFilterChange($event)" (onPage)="onPageChange($event)" (onSort)="onSort($event)"
        (selectionChange)="onSelectionChange($event)">
        <ng-template pTemplate="caption" *ngIf="showSelectMenue">
          <a id="GroupingMenuToggler"  type="button" status="primary"   *ngIf="hasGrouping"
          (click)="showGroupMenu = !showGroupMenu" nbButton class="aube-btn-outline rounded-circle btn-color-lightblue ">
            <i class="pi pi-fw pi-list"></i>
          </a>
          <p-multiSelect [options]="hideColumnOptions" [(ngModel)]="columns" [ngModelOptions]="{standalone: true}" optionLabel="name"
            [selectedItemsLabel]="'shared.columnsSelected' | translate" [style]="{ width: '50em' }" display="chip" [maxSelectedLabels]="10"></p-multiSelect>
            <p-button
            *ngIf="hasExport"
            icon="pi pi-external-link"
            styleClass="p-button-success p-button-rounded p-button-outlined custom-export-button"
            [pTooltip]="'shared.exportToExcel' | translate"
            tooltipPosition="top"
            iconPos="left"
            (click)="exportExcel2()" />

          </ng-template>
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
               <col *ngIf="canSelect" style="width: 3rem">
               <col *ngFor="let col of columns" [style.width]="col.width
               ? 'calc(100% / ' + columns.length + ' * ' + col.width + ')'
               : 'calc(100% / ' + columns.length + ')'">
          </colgroup>
      </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th class="check-box-header" *ngIf="canSelect" scope="checkbox">
              <p-tableHeaderCheckbox *ngIf="viewMood === TableViewMood.RecordsView" id=""></p-tableHeaderCheckbox>
            </th>
            <th id="" [ngClass]="{
                'd-none': col.hidden,
                'hide-sort': col.removeSorting,
                'text-center': col.cssClass === 'text-center'
              }" [ngStyle]="{
                width: col.width
                  ? 'calc(100% / ' + columns.length + ' * ' + col.width + ')'
                  : 'calc(100% / ' + columns.length + ')',
              }" *ngFor="let col of columns; trackBy: trackByIndex" [scope]="col.field" [pSortableColumn]="col.field" pResizableColumn pReorderableColumn>
              <p-sortIcon *ngIf="!col.removeSorting" [field]="col.field"></p-sortIcon>
              {{ col.name | translate }}
              <p-columnFilter *ngIf="
                  col.type !== TableHeaderType.Boolean  && col.type !== TableHeaderType.Action &&
                  col.type !== TableHeaderType.Link && col.type !== TableHeaderType.clickAction &&
                  col.type !== TableHeaderType.Enum && !col.removeFlitter &&
                  !(col.type === TableHeaderType.Date && col.serverDateFilter) " [type]="col.type!" [field]="col.field"
                  [placeholder]="col.name | translate" display="menu">
              </p-columnFilter>
              <ngx-date-range-filter *ngIf="
                  col.type === TableHeaderType.Date && col.serverDateFilter && !col.removeFlitter"
                  [field]="col.field" [column]="col.name"
                  (apply)="onDateRangeFilter(col.field, $event)">
              </ngx-date-range-filter>
               <p-columnFilter
                *ngIf="
                   (col.type === TableHeaderType.Action || col.type === TableHeaderType.Link || col.type === TableHeaderType.clickAction) &&
                  
                  !col.removeFlitter
                "
                [type]="TableHeaderType.Text"
                [field]="col.field"
                [placeholder]="col.name | translate"
                display="menu"></p-columnFilter>
              <ngx-enum-filter *ngIf="
                  col.type !== TableHeaderType.Boolean &&
                  col.type === TableHeaderType.Enum &&
                  !col.removeFlitter" 
                  [enum]="col.enum" [field]="col.field" [column]="col.name" (filterMetadata)="onFilterChange($event)">
              </ngx-enum-filter>
              <ngx-bool-filter *ngIf="
                  col.type === TableHeaderType.Boolean && !col.removeFlitter
                " [field]="col.field" [column]="col.name" (filterMetadata)="onFilterChange($event)"></ngx-bool-filter>
            </th>
            <th class="action-header justify-content-center action sticky-action action-column-narrow" *ngIf="actions.length"
              [scope]="'actions'">
              {{ actionColumnTitle | translate }}
            </th>
            <th *ngIf="isFlag">
              <div class="d-flex align-items-center justify-content-center">
                <p-checkbox 
                (onChange)="changesForFlagEvent($event)"
                [binary]="true" 
                variant="filled" />
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
          <ng-container *ngTemplateOutlet="
              viewMood === TableViewMood.RecordsView ? recordsView : treeView;
              context: { $implicit: rowData }
            "></ng-container>
        </ng-template>
        <!-- If u want to use grouping tree view -->
        <ng-template #treeView let-rowData>
          <tr [class]="'group-row ' + 'level-row-' + rowData.index">
            <td [class]="'w-100 ' + 'level-' + rowData.index" colspan="999"
              (click)="rowData.isExpanded = !rowData.isExpanded">
              <i *ngIf="rowData.isExpanded" class="pi pi-angle-down"></i>
              <i *ngIf="!rowData.isExpanded" class="pi pi-angle-right"></i>
              <span class="key-name">
                {{ rowData['key'] }} - ( {{ rowData['count'] }} )
              </span>
            </td>
          </tr>
          <ng-container *ngIf="rowData.isExpanded">
            <ng-container *ngFor="let item of rowData['items']; trackBy: trackByIndex">
              <ng-container *ngTemplateOutlet="
                  item['key'] ? treeView : recordsView;
                  context: { $implicit: item }
                "></ng-container>
            </ng-container>
          </ng-container>
        </ng-template>
        <!-- Normal view with its cases -->
        <ng-template #recordsView let-rowData>
          <tr [ngClass]="[isRowClickable ? 'clickable-row' : '', rowData.rowClass || '']">
            <td *ngIf="canSelect" class="check-box-header">
              <p-tableCheckbox [id]="rowData.id" [value]="rowData"></p-tableCheckbox>
            </td>
            <td *ngFor="let col of columns; trackBy: trackByIndex" (click)="onRowClicked(rowData.id)"
                [class]="col.indicatorClass ? col.indicatorClass(rowData) : ''"

              [ngClass]="{ 'd-none': col.hidden, 'text-center': col.cssClass === 'text-center' }" [ngStyle]="{
                width: col.width
                  ? 'calc(100% / ' + columns.length + ' * ' + col.width + ')'
                  : 'calc(100% / ' + columns.length + ')',
                minWidth: col.minWidth
              }">
              <div [ngSwitch]="col.type">
                <!-- bool template -->
                <span *ngSwitchCase="TableHeaderType.Boolean">
                  <ng-container *ngIf="!col.useActivationTemplate">
                    <ng-container *ngIf="rowData[col.field]">
                      {{ 'shared.yes' | translate }}
                    </ng-container>
                    <ng-container *ngIf="rowData[col.field] == false">
                      {{ 'shared.no' | translate }}
                    </ng-container>
                    <ng-container *ngIf="rowData[col.field] == null">
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="col.useActivationTemplate">
                    <p-inputSwitch [(ngModel)]="rowData[col.field]" (ngModelChange)="rowData[col.field] = $event; activationToggled.emit(rowData)" [ngModelOptions]="{standalone: true}"></p-inputSwitch>
                  </ng-container>
                </span>
                <!-- Statues --Enum  -->
                <ng-container *ngIf="rowData[col.field]">
                  <span [class]="
                      (getEnumKeyByEnumValue(col.enum, rowData[col.field]) ||
                        'Default') + ' grid-status-chip'
                    " *ngSwitchCase="TableHeaderType.Enum">
                    @if (col.field === "approvalType"){

                    {{
                    col.field +
                    '.' +
                    rowData[col.field]
                    | translate
                    }}
                    }@else{

                    {{
                    col.field +
                    '.' +
                    getEnumKeyByEnumValue(col.enum, rowData[col.field])
                    | translate
                    }}
                    }
                    </span>
                </ng-container>
                <!-- Number template -->
                <span *ngSwitchCase="TableHeaderType.Numeric">
                  @if (col.field == 'approvalType') {
                    {{getApprovalType(rowData[col.field]) | translate}}
                    <!-- {{rowData[col.field] | translate}} -->
                  }@else {
                    <ng-container *ngIf="
                        rowData[col.field]?.length > 1000;
                        else normalNumerical
                      ">
                      {{ rowData[col.field] | number: '1.2-2' }}
                    </ng-container>
                    <ng-template #normalNumerical>
                      {{ rowData[col.field] }}
                    </ng-template>
                  }
                </span>
                <!-- Date template -->
                <span *ngSwitchCase="TableHeaderType.Date"[ngStyle]="col.style?.(rowData[col.field], rowData)"
>
                  
                 {{ col.formatter ? col.formatter(rowData[col.field], rowData) :  rowData[col.field] | date: 'dd/MM/yyyy' }}

                </span>

                 <!-- Date template -->
                <span *ngSwitchCase="TableHeaderType.Link"[ngStyle]="col.style?.(rowData[col.field])"
>
                  <a [href]="col.linkUrl?.(rowData[col.field])" target="_blank" style="text-decoration: underline;">
                 {{ col.formatter ? col.formatter(rowData[col.field], rowData) :  rowData[col.field]  }}
                </a>

                </span>
                 <span *ngSwitchCase="TableHeaderType.clickAction" [ngStyle]="col.style?.(rowData[col.field], rowData)" class="text-wrap">
                        <a
                          href="javascript:void(0)"
                          (click)="onClickAction(col, rowData, $event)"
                          class="click-action-link" style="text-decoration: underline;">
                          {{ col.formatter ? col.formatter(rowData[col.field], rowData) : rowData[col.field] }}
                        </a>
                      </span>


                <!-- Avatar -->
                <span *ngSwitchCase="TableHeaderType.Avatar">
                  <div class="avatar-container">
                    <img *ngFor="
                        let avatar of rowData[col.field];
                        trackBy: trackByIndex;
                        let i = index
                      " [class]="'order-' + i" [src]="avatar.avatar" alt="" srcset="" />
                  </div>
                </span>
                <!-- Avatar -->
                <span *ngSwitchCase="TableHeaderType.AssignUser">
                  <div class="avatar-container">
                    <div  class="avatar-group">
                      <div *ngIf="rowData[col.field]?.length+1 > 9" class="flex-center-all circle count">
                        +{{ rowData[col.field].length+1 }}
                      </div>
                      <div [ngStyle]="{ backgroundColor: colors[i % colors.length] }" class="flex-center-all circle stackholder"
                        *ngFor="let stackholder of rowData[col.field] ; let i = index">
                        <span [pTooltip]="stackholder.name" tooltipPosition="bottom">
                          {{ transform(stackholder.name)  }}
                        </span>
                        <!-- <button class="remove-btn" (click)="removeStackholder(stackholder.id)">
                          x
                        </button> -->
                      </div>
                    </div>
                  </div>
                </span>

                <!-- Status Badges for Action Plan Items Status -->
                <span *ngSwitchCase="TableHeaderType.StatusBadges" class="items-status-cell">
                  <span *ngFor="let status of rowData[col.field]"
                        class="badge badge-pill status-badge"
                        [title]="status.statusId"
                        [style.background-color]="getStatusColor(status.statusId)">
                    {{ status.countStatus }}
                  </span>
                </span>
                
                <!-- Date Range with F/T badges exactly like original AngularJS -->
                <span *ngSwitchCase="TableHeaderType.DateRange" class="btn-clmn">
                  <div *ngIf="rowData[col.field]?.hasFromDate">
                    <span class="start-date-badge">F</span>
                    {{ rowData[col.field]?.fromDate }}
                  </div>
                  <div *ngIf="rowData[col.field]?.hasToDate">
                    <span class="end-date-badge">T</span>
                    {{ rowData[col.field]?.toDate }}
                  </div>
                </span>
                
                <!-- <span *ngSwitchDefault> {{ rowData[col.field] }}</span> -->
                  <!-- <ng-container *ngIf="!col?.textWrap">
                    <span class="text-no-wrap" *ngSwitchDefault> {{ rowData[col.field] }}</span>
                  </ng-container>
                  <ng-container *ngIf="col?.textWrap">
                    <span *ngSwitchDefault> {{ rowData[col.field] }}</span>
                  </ng-container> -->
            <ng-container *ngIf="!col?.textWrap">
              <span
                class="text-no-wrap"
                *ngSwitchDefault
                [ngStyle]="col.style?.(rowData[col.field], rowData)"
                [attr.title]="col.cellTitle ? col.cellTitle(rowData[col.field], rowData) : null"
              >
                {{ col.formatter ? col.formatter(rowData[col.field], rowData) : rowData[col.field] }}
              </span>
            </ng-container>

            <ng-container *ngIf="col?.textWrap">
              <span
                *ngSwitchDefault
                [ngStyle]="col.style?.(rowData[col.field], rowData)"
                [attr.title]="col.cellTitle ? col.cellTitle(rowData[col.field], rowData) : null"
              >
                {{ col.formatter ? col.formatter(rowData[col.field], rowData) : rowData[col.field] }}
              </span>
            </ng-container>

                  
                
                <span *ngSwitchCase="TableHeaderType.Action"><a  class="row-click" (click)="onRowClick(rowData)" >{{ rowData[col.field] }}</a> </span>

              </div>
            </td>
            <!-- Actions Buttons -->
            <td *ngIf="actions.length" class="action-cell action sticky-action">
              <ng-container *ngFor="let action of actions">
                <button *ngIf=" ((action.visible || action.visible === undefined) &&
                (rowData[action.state?.['checkingFelid']] === action.state?.['showIf'] ||
                action.state === undefined))" (click)="onTakeAction(action, rowData)" [title]="
                    action.tooltipOptions?.tooltipLabel
                      ? (action.tooltipOptions?.tooltipLabel! | translate)
                      : ''
                  " type="button"  [ngClass]="action.styleClass ? action.styleClass : 'btn btn-outline-primary'"
>
                  <em *ngIf="action.label">{{ action.label | translate }}</em>
                  <i *ngIf="action.iconClass" [class]="action.iconClass"></i>
                  <i *ngIf="action.icon && !action['image']" [class]="action.icon"></i>
                  <span *ngIf="action['image']" [class]="'icon-image-wrapper ' + (action.icon || '')">
                    <img [src]="action['image']" [alt]="action.label || 'icon'" />
                  </span>
                  <!-- <em *ngIf="action.styleClass" [class]="action.styleClass"></em> -->
                </button>
              </ng-container>
            </td>
            <td *ngIf="isFlag">
              <div class="flag d-flex justify-content-center">
                <button class="flag-button active" *ngIf="rowData.isCriticalPath" (click)="confirmDialog(rowData)"><i class="fa-solid fa-flag"></i></button>
                <button class="flag-button" *ngIf="!rowData.isCriticalPath" (click)="confirmDialog(rowData)"><i class="fa-regular fa-flag"></i></button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
  </div>
</div>
